"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IngestVideosFactory = void 0;
class IngestVideosFactory {
    static sample(video = {}) {
        return {
            id: video.id || '12345678',
            channel: video.channel || {
                id: '098765',
                name: 'How much wood would a woodchuck chuk',
            },
            ingestJob: video.ingestJob || {
                id: '67891235',
            },
            ingestStartedAt: video.ingestStartedAt || new Date(),
            title: video.title || 'If a woodchuck could chuck wood',
            status: video.status || 'SUCCESSFUL',
        };
    }
}
exports.IngestVideosFactory = IngestVideosFactory;
//# sourceMappingURL=IngestVideosFactory.js.map